// Phase 1A Step 34 — Rollover twin headline cards (Protected vs Full).
// Extracted from RolloverTable.tsx for LOC ceiling.

import { fmtBig } from "./calc-utils.ts";

interface RolloverTwinCardsProps {
  protectedTotal: number;
  fullTotal: number;
  totalKeptBeforeFinal: number;
  finalWin: number;
  stake: number;
  weeks: number;
  takeout: number;
  symbol: string;
}

export function RolloverTwinCards({
  protectedTotal,
  fullTotal,
  totalKeptBeforeFinal,
  finalWin,
  stake,
  weeks,
  takeout,
  symbol,
}: RolloverTwinCardsProps): JSX.Element {
  const tkPct = Math.round(takeout * 100);
  const cards: ReadonlyArray<{
    tag: string;
    tagColor: string;
    label: string;
    num: number;
    sub: string;
    note: string;
    accent: boolean;
  }> = [
    {
      tag: "Recommended",
      tagColor: "var(--success)",
      label: `${tkPct}% Takeout · Protected`,
      num: protectedTotal,
      sub: `${symbol}${fmtBig(totalKeptBeforeFinal)} pocketed early · ${symbol}${fmtBig(finalWin)} final win`,
      note: "If chain breaks at any week, you keep everything taken out so far.",
      accent: false,
    },
    {
      tag: "Hypothetical",
      tagColor: "var(--accent)",
      label: "Full Rollover · All-in",
      num: fullTotal,
      sub: `${symbol}${stake.toLocaleString()} restaked → ${weeks} consecutive wins required`,
      note: "Massive upside, brutal if the chain breaks anywhere along the way.",
      accent: true,
    },
  ];

  return (
    <div
      className="sz-l-rollover-twin"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 16,
        marginBottom: 24,
      }}
    >
      {cards.map((c, i) => (
        <div
          key={i}
          style={{
            background: c.accent
              ? "linear-gradient(180deg, #1A1408 0%, #0E0E0E 100%)"
              : "var(--surface)",
            border: c.accent ? "1px solid var(--accent-deep)" : "1px solid var(--border)",
            padding: "28px 32px 32px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 14,
            }}
          >
            <span
              className="mono"
              style={{
                fontSize: 10,
                letterSpacing: "0.18em",
                color: c.tagColor,
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              · {c.tag}
            </span>
            <span
              className="mono"
              style={{
                fontSize: 10,
                letterSpacing: "0.16em",
                color: "var(--text-dim)",
                textTransform: "uppercase",
              }}
            >
              {c.label}
            </span>
          </div>
          <div
            className="display"
            style={{
              fontSize: "clamp(54px, 6vw, 88px)",
              color: c.accent ? "var(--accent)" : "var(--text)",
              lineHeight: 0.9,
              marginBottom: 12,
              whiteSpace: "nowrap",
            }}
          >
            <span
              style={{
                fontSize: "0.5em",
                verticalAlign: "0.18em",
                marginRight: "0.08em",
              }}
            >
              {symbol}
            </span>
            {fmtBig(c.num)}
          </div>
          <div
            className="mono"
            style={{
              fontSize: 11,
              color: "var(--text-muted)",
              letterSpacing: "0.08em",
              marginBottom: 12,
            }}
          >
            {c.sub}
          </div>
          <div
            style={{
              fontSize: 13,
              color: "var(--text-muted)",
              lineHeight: 1.5,
              paddingTop: 14,
              borderTop: "1px solid var(--border)",
            }}
          >
            {c.note}
          </div>
        </div>
      ))}
    </div>
  );
}
